import { EntitlementsInterfaceV1 } from './EntitlementsInterfaceV1';
import { EntitlementsInterfaceType } from './types';

let entitlementsInterfaceV1: EntitlementsInterfaceV1;

export function getEntitlementsInterfaceV1(): EntitlementsInterfaceV1 {
  return entitlementsInterfaceV1;
}

/**
 * Initialize the Entitlements interface V1
 *
 * @returns Entitlements interface object
 */
export async function initializeEntitlementsInterfaceV1(): Promise<EntitlementsInterfaceType> {
  if (entitlementsInterfaceV1) return entitlementsInterfaceV1.getInterface();

  // Create an instance of the new EntitlementsInterfaceV1 class
  entitlementsInterfaceV1 = new EntitlementsInterfaceV1();

  // Return the interface methods
  return entitlementsInterfaceV1.getInterface();
}

// Keep backward compatibility
export default initializeEntitlementsInterfaceV1;
